import { Redirect } from "react-router-dom";

export const RouteAuth1099: React.FC<{ isAuthenticated?: boolean }> = ({
  isAuthenticated
}) => {
  if (isAuthenticated) {
    return (
      <Redirect to="/member/1099-filing/tax-information/verify-identity" />
    );
  }

  return <Redirect to="/member/sign-in" />;
};
